import { Auth0Client, createAuth0Client } from '@auth0/auth0-spa-js';

let auth0Client: Auth0Client | undefined;

interface InitAuth0Args {
  domain: string;
  clientId: string;
  audience: string;
}

export async function initAuth0({ domain, clientId, audience }: InitAuth0Args) {
  auth0Client = await createAuth0Client({
    domain: domain,
    clientId: clientId,
    authorizationParams: {
      audience: audience,
      redirect_uri: `${window.location.origin}/oauth2-callback/`,
      scope:
        'openid profile email read:metadata read:task create:task read:productCategory update:task delete:task read:inAppNotifications manage:connections',
    },
  });

  return auth0Client;
}

export function getAuth0Client() {
  return auth0Client;
}

export function clearAuth0Client() {
  auth0Client = undefined;
}
